<template lang="pug">
.shopping-cart
    component.cart-summary(v-if="qty && cart.articlePivots && cart.articlePivots.length" :is="cartComponent.is" v-bind="cartComponent.props")
        span.icon.is-medium
            i.fas.fa-shopping-cart
        span.pill(v-if="qty > 0 && qty < 100") {{ qty }}
        span.pill.much(v-else-if="qty > 0 && qty >= 100")
            span.limited 99+
            span.full {{ qty }}
        span.price {{ price }}
</template>

<script>
import { mapGetters } from 'vuex';

import { get } from '@/helpers';
import { moneyFormat } from '@/filters';

export default {
    name: 'ShoppingCart',
    computed: {
        qty() {
            return get(this.cart, 'qty') || 0;
        },
        tax() {
            const tax = get(this.cart, 'tax') || 0;

            const code =
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR';

            return moneyFormat(tax, code);
        },
        price() {
            let sum = get(this.cart, 'sum') || 0;

            sum += this.shippingFee;

            // const tax = get(this.cart, 'tax') || 0;
            // sum = sum - tax;

            const code =
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR';

            return moneyFormat(sum, code);
        },
        checkoutRoute() {
            let path;
            this.cms.menus.forEach(menu => {
                const item = menu.menuItems.find(item => get(item, 'page.view') === 'Checkout');
                if (item && item.path && !path) {
                    path = item.path;
                    return;
                }
            });
            return path;
        },
        cartComponent() {
            let cartComponent = {
                is: 'div',
                props: {}
            };
            if (this.checkoutRoute) {
                cartComponent.is = 'router-link';
                cartComponent.props.to = this.checkoutRoute;
            }
            return cartComponent;
        },
        ...mapGetters({
            cms: 'CMS',
            member: 'auth/member',
            customer: 'shop/customer',
            defaultCustomerGroup: 'shop/defaultCustomerGroup',
            shippingFee: 'shop/shippingFee',
            cart: 'shop/cart',
            menus: 'menus'
        })
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

.cart-summary
  display: flex
  align-items: center
  flex-direction: row
  position: relative
  .icon
    align-items: center
    display: inline-flex
    justify-content: center

  .pill
    position: relative
    line-height: 1.2
    height: 14px
    text-align: center
    background: red
    top: -10px
    left: -22px
    font-weight: bold
    padding: 1px 3px
    // padding-left: 5px
    border-radius: 10px
    color: white
    font-size: .65rem
    margin-right: -10px
    display: inline-block
    cursor: default
    width: 15px
    height: 15px
    &.much
      .limited
        display: initial
      .full
        display: none
      &:hover
        .limited
          display: none
        .full
          display: initial
</style>
